import { render, staticRenderFns } from "./ButtonExportReportPatient.vue?vue&type=template&id=39d33f68&"
import script from "./ButtonExportReportPatient.vue?vue&type=script&lang=js&"
export * from "./ButtonExportReportPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports